import { get } from "helpers/api_helper"

export const fetchDashboard = () => get("/admin/dashboard")
